import { DataSourceType } from "@coeff/api";
import React from "react";
import styled from "styled-components";

import { Graphics, type GraphicsProps } from "../../common/Graphics";
import { ConnectPlugIcon } from "../../common/Icons";
import { ImportTypeIcon } from "../../common/ImportTypeIcon";

interface PPressAuthGraphicsProps {
  dataSourceType?: DataSourceType;
}

const StyledGraphics = styled(Graphics)`
  .ant-avatar {
    width: 60px;
    height: 70px;

    svg {
      width: 60px;
      height: 60px;
      position: relative;
      top: 4px;
    }
  }
`;

export const AuthGraphics = ({
  dataSourceType,
  graphics,
  ...graphicsProps
}: PPressAuthGraphicsProps & GraphicsProps) => {
  return (
    <StyledGraphics
      graphics={
        <div className="graphicsLogo">
          <ConnectPlugIcon />
          <ImportTypeIcon type={dataSourceType} />
        </div>
      }
      {...graphicsProps}
    />
  );
};
